"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.tunnelSdkUserAgent = void 0;
// Get the package version
const packageJson = require("./package.json");
const packageVersion = packageJson.version;
/**
 * Tunnel SDK user agent
 */
exports.tunnelSdkUserAgent = `Dev-Tunnels-Service-TypeScript-SDK/${packageVersion}`;
//# sourceMappingURL=version.js.map